// carga idempotente por src (evita cargar 2 veces)
const scriptPromises = new Map();

export default function loadScript(src) {
  if (scriptPromises.has(src)) return scriptPromises.get(src);

  const p = new Promise((resolve, reject) => {
    // si ya existe y está cargado
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing?.dataset.loaded === "true") return resolve();

    const script = existing || document.createElement("script");
    script.src = src;
    script.async = true;

    const cleanup = () => {
      script.removeEventListener("load", onLoad);
      script.removeEventListener("error", onError);
    };

    const onLoad = () => {
      script.dataset.loaded = "true";
      cleanup();
      resolve();
    };

    const onError = (e) => {
      cleanup();
      reject(e);
    };

    script.addEventListener("load", onLoad);
    script.addEventListener("error", onError);

    if (!existing) document.head.appendChild(script);
  });

  scriptPromises.set(src, p);
  return p;
}
